import { type ReactNode } from 'react'

import { useIsLoggingOut } from 'store'

interface Props {
  children: ReactNode
}

export const SessionTransitionGate = ({
  children
}: Props) => {
  const isLoggingOut = useIsLoggingOut()

  if (isLoggingOut) {
    return null
  }

  return <>{children}</>
}